import React from "react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import type { BrokerTradeSyncInfo } from "../../utils/brokerTradeSync";
import { ibkrOlderHistoryChoiceMessage } from "../../utils/brokerTradeSync";
import {
  BROKER_ALERT_CLASS,
  BROKER_ALERT_DESC_CLASS,
  BrokerAlertIcon,
} from "./brokerAlertUi";

export interface IbkrHistoryPathBannerProps {
  tradeSync: BrokerTradeSyncInfo;
}

const IbkrHistoryPathBanner = ({ tradeSync }: IbkrHistoryPathBannerProps): React.ReactElement => {
  return (
    <Alert variant="warning" className={`mb-4 ${BROKER_ALERT_CLASS}`}>
      <BrokerAlertIcon tone="warning" />
      <AlertDescription className={BROKER_ALERT_DESC_CLASS}>
        {ibkrOlderHistoryChoiceMessage(tradeSync)}
      </AlertDescription>
    </Alert>
  );
};

export default IbkrHistoryPathBanner;
